"use client";

import { useTranslations } from "next-intl";
import {
    LessonSequenceImage1,
    LessonSequenceImage2,
    LessonSequenceImage3,
    LessonSequenceImage4,
    LessonSequenceImage5,
    LessonSequenceImage6,
    LessonSequenceImage7,
    LessonSequenceImage8,
    LessonSequenceImage9,
    LessonSequenceImage10,
} from "../../assets";
import UserGuideImage from "./UserGuideImage";

export default function LessonSequenceGuide() {
    const t = useTranslations("lessonSequence");

    return (
        <article className="mx-auto max-w-4xl px-6 py-8 text-[15px] leading-relaxed text-neutral-800 sm:px-10 sm:py-10 sm:text-base">
            <h1 className="mb-8 text-center text-xl font-bold sm:text-2xl">
                {t("headerTitle")}
            </h1>

            <p className="mb-6 whitespace-pre-wrap indent-8 text-justify">
                {t("title")}
            </p>

            <p className="mb-4 indent-4 text-justify">
                {t("step1")}
            </p>

            <p className="mb-4 indent-4 text-justify">
                {t("step2")}
            </p>

            <p className="mb-4 indent-4 text-justify">
                {t("step3")}
            </p>

            <div className="mb-6">
                <UserGuideImage image={LessonSequenceImage1} />
            </div>

            <p className="mb-4 indent-4 text-justify">
                {t("step4")}
            </p>

            <p className="mb-4 indent-4 text-justify">
                {t("step5")}
            </p>

            <p className="mb-4 indent-4 text-justify">
                {t("step6")}
            </p>

            <div className="mb-6">
                <UserGuideImage image={LessonSequenceImage2} />
            </div>

            <p className="mb-4 indent-4 text-justify">
                {t("step7")}
            </p>

            <div className="mb-6">
                <UserGuideImage image={LessonSequenceImage3} />
            </div>

            <p className="mb-4 whitespace-pre-line indent-4 text-justify">
                {t("step8")}
            </p>

            <div className="mb-6">
                <UserGuideImage image={LessonSequenceImage4} />
            </div>

            <p className="mb-4 indent-4 text-justify">
                {t("step9")}
            </p>

            <p className="mb-4 indent-4 font-bold text-justify">
                {t("howTo1")}
            </p>

            <p className="mb-4 indent-4 text-justify">
                {t("howTo1Detail")}
            </p>

            <div className="mb-6">
                <UserGuideImage image={LessonSequenceImage5} />
            </div>

            <p className="mb-4 indent-4 font-bold text-justify">
                {t("howTo2")}
            </p>

            <p className="mb-4 indent-4 text-justify">
                {t("howTo2Detail")}
            </p>

            <div className="mb-6">
                <UserGuideImage image={LessonSequenceImage6} />
            </div>

            <div className="mb-6">
                <UserGuideImage image={LessonSequenceImage7} />
            </div>

            <p className="mb-4 indent-4 text-justify">
                {t("step10")}
            </p>

            <p className="mb-4 indent-4 text-justify">
                {t("step11")}
            </p>

            <p className="mb-4 indent-4 text-justify">
                {t("step12")}
            </p>

            <div className="mb-6">
                <UserGuideImage image={LessonSequenceImage8} />
            </div>

            <p className="mb-4 indent-4 text-justify">
                {t("step13")}
            </p>

            <div className="mb-6">
                <UserGuideImage image={LessonSequenceImage9} />
            </div>

            <p className="mb-4 indent-4 text-justify">
                {t("step14")}
            </p>

            <div className="mb-6">
                <UserGuideImage image={LessonSequenceImage10} />
            </div>
        </article>
    );
}
